import { UtilityRedirectModal } from './utility-modal.component';

// Pages must be default exports for lazy loading
// eslint-disable-next-line import/no-default-export
export default UtilityRedirectModal;
